import { useEffect, useState } from "react";

export default function useSidebarPreference(section: "primary" | "settings") {
  const key = `meraai.sidebar.${section}.collapsed`;
  const [collapsed, setCollapsed] = useState(() => {
    try { return window.localStorage.getItem(key) === "true"; }
    catch { return false; }
  });

  useEffect(() => {
    try { window.localStorage.setItem(key, String(collapsed)); }
    catch { /* The controls still work when browser storage is unavailable. */ }
  }, [key, collapsed]);

  return [collapsed, () => setCollapsed(value => !value)] as const;
}
